import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import TrustCenterApprovedAccessPage from '@/pages/trust-center/public/TrustCenterApprovedAccessPage'

const searchSchema = z.object({
  email: z.string().optional(),
})

export const Route = createFileRoute('/trust/access/$token')({
  validateSearch: searchSchema,
  component: TrustCenterApprovedAccessPage,
})
